import React from 'react';
import { HashRouter } from 'react-router-dom';

import App from './App';
import IntlContainer from '@app/src/IntlContainer';
import AuthProvider from '@app/src/AuthProvider';
import DndContainer from '@app/src/DndContainer';

const AppProvider = () => (
  <DndContainer>
    <AuthProvider>
      <IntlContainer>
        <HashRouter>
          <App />
          <div id="app-overlay" className="app-overlay" />
        </HashRouter>
      </IntlContainer>
    </AuthProvider>
  </DndContainer>
);

export default AppProvider;
